/**
 * Created by ferto
 * Marciano Digital Agency
 * www.marciano.com.mx
 * Date: 01/02/2018.
 *
 * index Vue Store
 */

export default {
  namespaced: true,
  state: {
    items: {
      super_admin: [
        {
          name: 'GENERAL',
          items: [
            {
              name: 'Dashboard',
              route: 'dashboard'
            },
            {
              name: 'Distribuidores',
              route: 'dealers'
            },
            {
              name: 'Sucursales',
              route: 'branches'
            },
            {
              name: 'Evaluaciones',
              route: 'evaluations'
            }
          ]
        },
        {
          name: 'REPORTES',
          items: [
            {
              name: 'Descargas',
              route: 'reports'
            }
          ]
        },
        {
          name: 'ADMINISTRADOR',
          items: [
            {
              name: 'Usuarios',
              route: 'users'
            },
            {
              name: 'Periodos',
              route: 'periods'
            },
            {
              name: 'Layouts',
              route: 'layouts'
            },
            {
              name: 'Asignaciones',
              route: 'assignments'
            }
          ]
        }
      ],
      pollster: [
        {
          name: 'MENÚ',
          items: [
            {
              name: 'Dashboard',
              route: 'dashboard'
            },
            {
              name: 'Distribuidores',
              route: 'dealers'
            },
            {
              name: 'Sucursales',
              route: 'branches'
            },
            {
              name: 'Evaluaciones',
              route: 'evaluations'
            }
          ]
        }
      ],
      dealer_chief: [
        {
          name: 'MENU',
          items: [
            {
              name: 'Dashboard',
              route: 'dashboard'
            },
            {
              name: 'Mi Distribución',
              route: 'dealers'
            },
            {
              name: 'Sucursales',
              route: 'branches'
            },
            {
              name: 'Evaluaciones',
              route: 'evaluations'
            }
          ]
        }
      ],
      dealer: [
        {
          name: 'MENU',
          items: [
            {
              name: 'Dashboard',
              route: 'dashboard'
            },
            {
              name: 'Mi Distribución',
              route: 'dealers'
            },
            {
              name: 'Sucursales',
              route: 'branches'
            },
            {
              name: 'Evaluaciones',
              route: 'evaluations'
            }
          ]
        }
      ],
      branch_chief: [
        {
          name: 'MENU',
          items: [
            {
              name: 'Dashboard',
              route: 'dashboard'
            },
            {
              name: 'Mi Distribución',
              route: 'dealers'
            },
            {
              name: 'Sucursales',
              route: 'branches'
            },
            {
              name: 'Evaluaciones',
              route: 'evaluations'
            }
          ]
        }
      ]
    }
  },
  getters: {
    items: (state, getters, rootState, rootGetters) => {
      return state.items[rootGetters['profile/me'].role]
    }
  },
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/menu/index.js